<template>
  <div ref="layout" class="page-container">
    <div class="query-title">发货计划单查询</div>
    <div class="content table-query">
      <collapse-query2>
        <template slot="content">
          <div class="query-container">
            <el-form inline class="form" size="mini" label-width="100px">
              <el-row>
                <el-col :span="8">
                  <el-form-item label="客户编码">

                    <wly-input
                      ref="custInput"
                      v-model="conditions.partner"
                      input-type="customer"
                      clearable
                      @handleSuffixClick="showDialog = true"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="营销单元">
                    <el-select
                      v-model="conditions.yxdy"
                      placeholder="请选择"
                      type="select"
                      filterable
                      clearable
                    >
                      <el-option
                        v-for="item in selectDataOptions['orgList']"
                        :key="item.SOBID"
                        :label="item.MC_SHORT"
                        :value="item.SOBID"
                      />
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="时间">
                    <el-date-picker
                      v-model="conditions.fillinDate"
                      type="date"
                      value-format="yyyy-MM-dd"
                    />
                  </el-form-item>
                </el-col>
              </el-row>
              <el-button size="mini" icon="el-icon-refresh-right" @click="reset">重置</el-button>
              <el-button size="mini" icon="el-icon-search" type="primary" @click="queryData(1)">查询</el-button>
            </el-form>
          </div>
        </template>
      </collapse-query2>

      <div class="table-container">
        <TableCommon
          title="明细"
          :custome-config="() => vxeShowCustom('gridOptions')"
          :pagination="pagination"
          @pagination-change="handleTablePaginationChange"
        >
          <vxe-grid
            ref="gridOptions"
            class="table-block"
            border
            :highlight-hover-row="true"
            resizable
            :show-overflow="true"
            max-height="500"
            align="center"
            size="mini"
            :empty-render="{ name: 'NotData' }"
            :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
            :edit-config="{ trigger: 'manual', mode: 'row' }"
            :columns="gridOptions.columns"
            :data="gridOptions.data"
          />
        </TableCommon>
      </div>

    </div>

    <!-- 通用弹窗情况 -->
    <el-dialog v-dialogDrag title="客户选择" :visible.sync="showDialog" width="70%" :append-to-body="true">

      <client-select v-if="showDialog" ref="dialogEdit" />

      <div slot="footer">
        <el-button
          type="default"
          icon="el-icon-circle-close"
          size="small"
          @click="showDialog = false"
        >取消</el-button>
        <el-button
          type="primary"
          icon="el-icon-circle-check"
          size="small"
          @click="submitHandle"
        >确认</el-button>
      </div>
    </el-dialog>

  </div>
</template>
<script>
import { apiGetOrgOrBase } from '@/api/sap/common-sap'
const ClientSelect = () => import('@/components/dialog/ClientSelect.vue')
import { apiDeliveryPlanOrder } from '@/api/applyForGoods/monthly'
export default {
  name: 'delivery-plan-order',
  components: { ClientSelect },
  data() {
    return {
      showDialog: false,
      loading: false,
      pagination: {
        page: 1,
        pagesize: 50,
        totalCount: 0
      },
      conditions: {
        yxdy: '',
        partner: '',
        fillinDate: ''
      },
      selectDataOptions: {},
      gridOptions: {
        columns: [
          { field: 'billCode', title: '单据编号' },
          { field: 'partner', title: '客户编码' },
          { field: 'partnerName', title: '客户名称' },
          //   { field: 'brand', title: '存货分类编码' },
          //   { field: 'brandName', title: '存货分类描述' },
          //   { field: 'zqdlxTextView', title: '渠道类型' },
          { field: 'yxdy', title: '营销单元编码' },
          { field: 'yxdyName', title: '营销单元描述' },
          // { field: 'pyear', title: '实际年度' },
          { field: 'createdDate', title: '创建时间' },
          { field: 'statusTextView', title: '单据状态', width: 120 }
        //   { field: 'yxdy', title: '月份' },
        //   { field: 'yxdy', title: '计划量' },
        //   { field: 'yxdy', title: '发货量(审核中)' },
        //   { field: 'yxdy', title: '发货量(归档中)' },
        //   { field: 'yxdy', title: '剩余量' }
        ],
        data: []
      }
    }
  },
  created() {
    this.getOrg()
  },
  methods: {
    async queryData(page) {
      page && (this.pagination.page = page)
      const params = {
        ...this.conditions,
        ...this.pagination
      }
      const {
        data: { Rows, Total }
      } = await apiDeliveryPlanOrder(params)

      this.gridOptions.data = Rows
      this.pagination.totalCount = Total
    },
    async getOrg() {
      const { DATA } = await apiGetOrgOrBase('', 1)
      this.$set(this.selectDataOptions, 'orgList', DATA)
    },
    handleTablePaginationChange(page) {
      Object.assign(this.pagination, page)
      this.queryData()
    },
    async submitHandle() {
      const data = await this.$refs.dialogEdit.submitForm()
      if (data) {
        this.conditions.partner = data.customerCode
      }
      this.showDialog = false
    },
    reset() {
      this.conditions = {
        partner: '',
        yxdy: '',
        fillinDate: ''
      }
    }
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/views/apply-for-manage/data-searching/deliveryPlanOrder.vue